import { Application } from '@hotwired/stimulus'
import { registerControllers } from 'stimulus-vite-helpers'

const app = Application.start()
window.Stimulus = app
const controllers = import.meta.glob('./**/*_controller.ts', { eager: true })
const jsControllers = import.meta.glob('./**/*_controller.js', { eager: true })
registerControllers(app, controllers)
registerControllers(app, jsControllers)
